import React, { useState, createContext, useContext, useEffect } from 'react';
import { JSONContext } from '../Store';
// import VisualizationsNavBar from './VisualizationsNavBar';
import { Link, useNavigate } from 'react-router-dom';

import TableModule from '../tableModule/TableModule';
//import TableModule from 'odisea_tablas';
//import MapsCEPAL from '../visualization_modules/maps/maps.react.js';
import MapsCEPAL from '../visualization_modules/maps2/index.react.js';
import VisualizationsSPC from './VisualizationsSPC';
import NavBar from './NavBar';
import LoadingSpinner from './LoadingSpinner';

// import censusVariablesConfig from './censusVariablesConfig';
import { Tabs, Tab, Spinner, Form, Row, Col } from 'react-bootstrap';
import { Buffer } from 'buffer';
import { ENDPOINT_DEPOT, getLayersConfig } from './admin/apiCalls';
import { store, StateProvider } from '../Store';

export default function Visualizations(props) {

  const { state, dispatch } = useContext(store);
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;

  const {responseJSON, firstResponseJSON, textSPC, formTypeQuery, formData, isLoading, setIsLoading} = useContext(JSONContext);

  // to reload map tab when it's selected, to avoid selector conflicts between maps and table sources
  const [key, setKey] = useState('maps');
  const [isTableLoading, setIsTableLoading] = useState(true);

  const dataset64 = Buffer.from(
    // JSON.stringify({...firstResponseJSON, 'path': ENDPOINT_DEPOT + '/tempo'}),
    JSON.stringify({...firstResponseJSON, 'path': ENDPOINT_DEPOT + '', id: firstResponseJSON.redsessionid}),
    'utf8'
  ).toString('base64');
  //const dataset64 = 'pending';
  //const dataset64 = btoa(responseJSON);

  // <Nav.Link eventKey="disabled" disabled> for disabled tabs

  //const navigate = useNavigate();

  //if (formTypeQuery === '') {navigate('/')};
  
  const [mapOptions, setMapOptions] = useState({});
  const [selectedTableSource, setSelectedTableSource] = useState(0);
  const [layersConfig, setLayersConfig] = useState({}); 
  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));

  const navigate = useNavigate();

  useEffect(() => {
    if (!formData || !formData?.selectedResultType) {
      navigate('/');
    }
  }, [formData]);

  useEffect(() => {
    setIsLoading(true);
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  }, []);

  useEffect(() => {

    getLayersConfig((response) => {
      setLayersConfig(response);
    });

  }, [selectedTableSource, responseJSON]);

  
  useEffect(() => {
    updateMapConfig();
  }, [layersConfig]);

  const styleTheme = {
    'navLink': `${configData?.theme && configData.theme}-nav-link`,
  }


  const updateMapConfig = () => {

    
    // set a temporary variable, inside the function
    let configMapOptions = {
      options: {
        'geoJSON': layersConfig?.[formData.selectedDA] && layersConfig[formData.selectedDA]['geoJSON'],
        'centroids': layersConfig?.[formData.selectedDA] && layersConfig[formData.selectedDA]['centroids'],
        'codeFeature': layersConfig?.[formData.selectedDA] && layersConfig[formData.selectedDA]['codeFeature'],
        'codeFeatureNum': layersConfig?.[formData.selectedDA] && layersConfig[formData.selectedDA]['codeFeatureNum'],
        languageFolder: "assets/lang/"
      },
      modules: []
    }

    let matrixJSONPath = '';
    let indicatorsJSONPath = '';

    // add indexes and matrix options to maps
    //responseJSON.map((responseJSONItem) => {
    if (responseJSON[selectedTableSource]?.path) {
      const parsedData = JSON.parse(responseJSON[selectedTableSource].data); // REVIEW!!!!!!!!!
      if (parsedData?.type) {
        switch (parsedData.type) {
          case 'FREQUENCY':
            matrixJSONPath = ENDPOINT_DEPOT + '/' + responseJSON[selectedTableSource].path;
            break;
          case 'AREALIST':
            indicatorsJSONPath = ENDPOINT_DEPOT + '/' + responseJSON[selectedTableSource].path;
            break;
          default:
            break;
        }
      }
    }
    //});

    if (formData && formData?.selectedResultType && formData.selectedResultType.includes('matrix') & matrixJSONPath !== '') {
      switch (formTypeQuery) {
        case 'migration':
          configMapOptions = {
            ...configMapOptions,
            modules: [
              ...configMapOptions.modules, {
                module: 'migration',
                active: true,
                options: {
                  dataJSON: matrixJSONPath //outJsonPath
                }
              }
            ]
          };
          break;
        case 'mobility':
          configMapOptions = {
            ...configMapOptions,
            modules: [
              ...configMapOptions.modules, {
                module: 'mobility',
                active: true,
                options: {
                  dataJSON: matrixJSONPath //outJsonPath
                }
              }
            ]
          };
          break;
        default:
          break;
      }
    }
  
    // Indexes for maps:
    if (formData && formData?.selectedResultType && formData.selectedResultType.includes('indicators') & indicatorsJSONPath !== '') {
      switch (formTypeQuery) {
        case 'segregation':
          configMapOptions = {
            ...configMapOptions,
            modules: [
              ...configMapOptions.modules, {
                module: 'segregation',
                active: true,
                options: {
                segregationJSON: indicatorsJSONPath
                }
              }
            ]
          };
          break;
        default:
          configMapOptions = {
            ...configMapOptions,
            modules: [
              ...configMapOptions.modules, {
                module: 'tablelist',
                options: {
                  tablelistJSON: indicatorsJSONPath
                }
              }
            ]
          };
          break;
      }
    }

    setMapOptions(configMapOptions);

  }

  const selectSource = (
    <Form className="odisea-page-visualizations-source-selector">
      <p>{/* JSON.stringify(mapOptions) */}</p>
      <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
        <Form.Label column sm={1}>Resultado: </Form.Label>
        <Col sm={11}>
          <Form.Select
            id={ 'table-source-selector' }
            name={ 'table-source-selector' }
            className="form-select required"
            required="required"
            aria-required="true"
            value={ selectedTableSource }
            onChange={ (e) => {
              setSelectedTableSource(e.target.value)
            } }
          >
            {
              responseJSON.map((data, responseId) => 
                <option key={ responseId } value={ responseId.toString() }>{JSON.parse(data.data)?.metadata?.title && JSON.parse(data.data).metadata.title }</option>
              )
            }
          </Form.Select>
        </Col>
      </Form.Group>
    </Form>
  )

  const renderVisualizations = (
    <>
    <div className={ "odisea-page-visualizations " + styleTheme.navLink } >
    <NavBar />
    <Tabs onSelect={(k) => setKey(k)} defaultActiveKey="maps" id="tabs-visualization-modules" className="mb-3 justify-content-end">
      <Tab eventKey="maps" title="Mapas">
        {selectSource}
        {!isLoading && key==="maps" && <MapsCEPAL
          path={'visualization_modules/maps2'}
          options={mapOptions}
          style={{
              height: '80vh',
              minHeight: '600px',
              width: '100%'
          }}
        />
        }
      </Tab>
      <Tab eventKey="graphs" title="Gráficos">
        {!isLoading  && key==="graphs" && <iframe
          key={14645156488461} //</Tab>{spcOutKey}
          src={`visualization_modules/charts/index.html?lang=es&datasets=${dataset64}`}
          width="100%"
          height="800px"
          style={{
            height: '80vh',
            minHeight: '600px',
            width: '100%'
          }}
          ></iframe>
        }
      </Tab>
      <Tab eventKey="tables" title="Listas">
        {selectSource}
        {!isLoading  && key==="tables" && <TableModule
          hiddenColumns={['$na$', '$mv$']}
          JSONData={ JSON.parse(responseJSON[selectedTableSource].data) }
          language="es"
          options={{
            decimalPlaces: 2,
            scientific: 'auto',
            scientificThreshold: 1e6,
            smallNumberThreshold: 1e-4,
            thousandSeparator: ' ',
            decimalSeparator: '.',
          }}/>}
      </Tab>
      <Tab eventKey="spcCode" title="Programa">
        <VisualizationsSPC textSourceCodeSPC={ textSPC }/>
      </Tab>
    </Tabs>
    </div>
    </>
  )

  return (
    <>
    {isLoading ? <LoadingSpinner visualization /> : renderVisualizations}
    </>
  )
}
